export default "__VITE_ASSET__949871cc__"